import { Compiler, Component, OnInit,AfterViewChecked ,ViewChild,ElementRef} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GridOptions } from "ag-grid";
import { Router, NavigationEnd } from '@angular/router';
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

declare var $: any;
interface dropdownTemplate {
  name: string;
  value: string;
}
@Component({
  selector: 'd2z-pdt',
  templateUrl: './pdt.component.html',
  styleUrls: ['./pdt.component.css']
})
export class PdtComponent implements OnInit, AfterViewChecked{
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  trackingPrintForm: FormGroup;
  shipmentAllocateForm: FormGroup;
  errorMsg: string;
  successMsg: String;
  englishFlag:boolean;
  chinessFlag:boolean;
  check:boolean;
  private gridOptions: GridOptions;
   rowData=[];
  serviceDropdown: dropdownTemplate[];  
  sizeOptions: dropdownTemplate[];  
  agentDropdown:dropdownTemplate[];
  selectedExportType: dropdownTemplate;
  selectedSize:dropdownTemplate;
  selectedService:dropdownTemplate;
  selectedAgent:dropdownTemplate;
  userName: String;

  constructor(
    public trackingDataService: TrackingDataService,
    private spinner: NgxSpinnerService,
    public consigmentUploadService: ConsigmentUploadService,
    private router: Router,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.trackingPrintForm = new FormGroup({
      refBarNum: new FormControl(),
      service: new FormControl(),
      agent: new FormControl()
    });
    this.shipmentAllocateForm = new FormGroup({
      shipmentNumber: new FormControl()
    });
    this.gridOptions = <GridOptions>{ rowSelection: "multiple" };
    this.gridOptions.columnDefs = [
      {
        headerName: "Article ID",
        field: "articleID",
        width: 500,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      },
      {
        headerName: "Agent",
        field: "carrier",
        width: 200
      }
    ];
  }

  ngOnInit() {
    this.userName =  this.consigmentUploadService.userMessage ? this.consigmentUploadService.userMessage.userName : '';
    console.log(this.userName)
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });

    this.trackingDataService.fetchPDTData(this.userName, (resp) => {        
        this.rowData = resp;
        this.check=false;
      });

    this.serviceDropdown = [
      { "name": "General Freight", "value": "General" },
      { "name": "Oversized Freight Remap", "value": "OversizedRemap" },
      { "name": "Oversized Freight Agent", "value": "Oversized" }]

      this.selectedService = this.serviceDropdown[0];

      this.sizeOptions = [
        { "name": "STD", "value": "STD" },
        { "name": "140", "value": "140" },
        { "name": "240", "value": "240" },
        { "name": "300", "value": "300" },
        { "name": "360", "value": "360" },
        { "name": "600", "value": "600" },
        { "name": "PAL", "value": "PAL" }]

        this.selectedSize = this.sizeOptions[0];

        this.agentDropdown = [ 
       //   { "name": "TV JPD", "value": "32" }, 
        { "name": "TV D2Z", "value": "21" },
        { "name": "TV ALL", "value": "7" },
        { "name": "TV BEN", "value": "8" },
        { "name": "TV CAL", "value": "9" },
       // { "name": "TV GIP", "value": "10" },
       // { "name": "TV MAC", "value": "11" },
        { "name": "TV SEN", "value": "12" },
        { "name": "TV MLD", "value": "18" },
        { "name": "TV SWH", "value": "19" },
        { "name": "TV YVT", "value": "20" },
        { "name": "TV WBL", "value": "63" },
        //{ "name": "TV GPC", "value": "22" },
        //{ "name": "TV RPD", "value": "27" },
     //   { "name": "TV AUSF", "value": "30" },
        { "name": "GIPNG", "value": "59" },
       // { "name": "TV ZTO", "value": "34" },
       { "name": "D2ZNG", "value": "47" },
       { "name": "BENNG", "value": "53" },
        { "name": "LME", "value": "33" },
          { "name": "FAST VIC", "value": "3" },
          { "name": "TOLL", "value": "23" },
          { "name": "POST", "value": "5" },
          { "name": "EXPRESS POST", "value": "29" },
          { "name": "PFL", "value": "1" },
          { "name": "HEY", "value": "64" },
        ];

        this.selectedAgent = this.agentDropdown[0];

        this.trackingDataService.fetchPDTData(this.userName, (resp) => {
            if(resp.status === 500){
            }else{
              this.rowData = resp;
              this.check=false;
            }
            
          })
          this.scrollToBottom();

  }
  ngAfterViewChecked() {        
    this.scrollToBottom();        
} 
scrollToBottom(): void {
  try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  } catch(err) { }                 
}
  downloadLable(){
    this.errorMsg=null;
    this.successMsg=null;
    var elem = document.getElementById("pdf-Util");
    var trackingNo = this.trackingPrintForm.value.refBarNum;
    var that = this;
    elem.onkeyup = function(e){
        if(e.code == 'Enter'){
          var numberOfLineBreaks = '';
          numberOfLineBreaks = (that.trackingPrintForm.value.refBarNum.match(/\n/g)||[]).length;
          if(that.trackingPrintForm.value.refBarNum != null && $("#pdf-Util").val().length > 1){
                that.spinner.show();
                var fileRefNum = that.trackingPrintForm.value.refBarNum.trim();
                 if (that.rowData.filter(function(e) { return e.articleID === fileRefNum; }).length > 0) {
                  that.spinner.hide();
                  that.trackingPrintForm.patchValue({
                    refBarNum: ''
                  })
                }else{
                that.trackingDataService.fetchAgent(that.userName,fileRefNum,"pdt", (resp) => {
                that.spinner.hide();
                  if(resp.status === 500){
                    that.errorMsg =' Invalid "Reference Number" or "BarCode label number"';
                  }else{
                    that.rowData.unshift({"articleID":resp.articleID,"carrier":resp.carrier,"chuteNumber":resp.chuteNumber});
                    that.trackingPrintForm.patchValue({
                      refBarNum: ''
                    })
                  }
                  that.gridOptions.api.setRowData(that.rowData);
                  
                  console.log(that.rowData);
                })
              }
          }else{
            that.spinner.hide();
            that.errorMsg =  '*Please enter the "Reference Number" or "barCode Label Number" to generate the PDF.';
          }
        }
    }
  }

  selectAll(event){
    this.rowData.forEach(data=>data.checked=event.target.checked)
  }

  onServiceChange(event){
    this.selectedService=event.value;
  }

  onSizeChange(event,articleID){
    let size = event.value.value;
    this.trackingDataService.updateSize(articleID,size, (resp) => {
      console.log(resp)
    //  this.trackingDataService.fetchPDTData( (resp) => {        
      //  this.rowData = resp;
       // this.check=false;
      //});
      })
  }
  allocatePDT(){
    this.spinner.show();
      let shipmentNumber = this.shipmentAllocateForm.value.shipmentNumber;
      let service = this.trackingPrintForm.value.service;
      let agent = this.trackingPrintForm.value.agent;
      let fieldArray = this.rowData;
      let request = [];
      this.errorMsg="";
      for(var field in fieldArray){
       let selected = fieldArray[field];
       if(selected.checked){
      var data = {
        "articleID" : selected.articleID,
        "carrier" : selected.carrier,
        "size": selected.size==null?this.selectedSize:selected.size

      }
      request.push(data);
      }}
      let supplier = "0";
      if(agent!=null){
        supplier = agent.value;
      }
      if(request.length>0){
      this.trackingDataService.allocatePDTdata(request,shipmentNumber,service.value,supplier, (resp) => {
        this.spinner.hide();
          if(resp.status === 500){
            this.errorMsg ='Unable to allocate. Please try again';
          }else{
            this.successMsg = "Allocated Successfully";
            this.downloadReport(resp); 
               
          }
        })
      }else{
        this.errorMsg = "Please select atleast one articleID";
      }
      }
  
  downloadReport(resp){
   
     if(resp.length > 0 ){
         var currentTime = new Date();
         var consignmentList = [];
         var fileName = '';
             fileName = "Report"+"-"+currentTime.toLocaleDateString();
           var options = { 
             fieldSeparator: ',',
             quoteStrings: '"',
             decimalseparator: '.',
             showLabels: true, 
             useBom: true,
             headers: [ 
               "Article ID",
               "Result",
             ]
           };
           let articleID='articleID';
           let status = 'status';
         
           for (var val in resp) {
               var data = resp[val];
               var importObj = (
                   importObj={},
                   importObj[articleID]= data.articleID != null ? data.articleID: '', importObj,                  
                   importObj[status]= data.status != null ? data.status : '', importObj
                 
               );
               consignmentList.push(importObj)
           }
         new Angular2Csv(consignmentList, fileName, options);  
         let request = [];
         for(var field in consignmentList){
         request.push(consignmentList[field].articleID);
         }  
         this.trackingDataService.updateStatus(request,"Downloaded", (resp) => {
          console.log(resp)
          this.trackingDataService.fetchPDTData(this.userName, (resp) => {        
            this.rowData = resp;
            this.check=false;
          });
          })
       }else{
        
         this.errorMsg = "Unable to allocate. Please try again";
         
       } 
   }
   
  remove(){
    let request=[];
    let consignmentList = this.rowData;
    for(var field in consignmentList){
      if(consignmentList[field].checked){
     request.push(consignmentList[field].articleID);
      }
     } 
     console.log(request);
     if(request.length>0){
      this.trackingDataService.deletePDTdata(request, (resp) => {
        this.spinner.hide();
          if(resp.status === 500){
            this.errorMsg ='Unable to remove. Please try again';
          }else{
            this.trackingDataService.fetchPDTData( this.userName,(resp) => {        
              this.rowData = resp;
              this.check=false;
            });               
          }
        })
      }else{
        this.errorMsg = "Please select atleast one articleID";
      } 
  }
}




// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/pdt/pdt.component.ts